<template>
  <div class="cert-page">
    <layout-header :isFixedHeader="false"></layout-header>
    <div class="container">
      <section>
        <h1 class="title">인증 진행 현황</h1>
        <article>
          <div class="progress-wrap">
            <h2>진행 내용</h2>
            <ul>
              <li v-for="(cert, index) in certList" :key="index" @click="clickProgress(cert)">
                <div class="step">
                  <div class="number">{{ index + 1 }}</div>
                  <div class="progress">{{ cert.progress }}</div>
                </div>
                <div class="status" :class="{off: cert.isComplete === -1, on: cert.isComplete === 1}">
                  {{ cert.isComplete === 1 ? "완료" : "진행중" }}
                </div>
                <div class="progress-info">{{ findProgressStatus(cert.progressInfoList) }}</div>
              </li>
            </ul>
          </div>

          <div class="progress-detail-wrap">
            <h2>[{{ progressTitle }}] 세부 진행 현황</h2>
            <ul>
              <li v-for="(progress, index) in progressInfoList" :key="index">
                <div class="status-line">
                  <div class="circle" :class="{current: progress.isCurrentProgress === 1}"></div>
                </div>
                <div class="status-title" :class="{current: progress.isCurrentProgress === 1}">
                  {{ progress.progressStatus }}
                </div>
              </li>
            </ul>
          </div>

          <div class="inquire-wrap">
            <h2>인증 문의</h2>
            <div class="cert_inquire_wrap">
              <div class="reply_wrap">
                <div v-show="!isWrite" @click="clickReplyWrap">문의를 남겨보세요.</div>
                <div v-show="isWrite">
                  <textarea placeholder="내용을 입력하세요." rows="8" ref="replyTextArea"></textarea>
                  <div class="button_wrap">
                    <div class="btn_cancel" @click="cancelReply">취소</div>
                    <div class="btn_submit" @click="submitReply">등록</div>
                  </div>
                </div>
              </div>
              <ul class="cert_inquire_ul">
                <li class="cert_inquire_li" v-for="(row, index) in certInquireList" :key="index">
                  <div class="write_wrap">
                    <div class="write_name" v-if="row.type === 1">{{ userData.companyName }}</div>
                    <div class="admin_name" v-else>{{ row.adminName }}</div>
                    <div class="write_date">{{ $moment(row.regDate).format('YYYY.MM.DD HH:mm') }}</div>
                  </div>
                  <div class="inquire_content" v-html="$Util.nl2br(row.content)"></div>
                  <div class="admin_reply" v-for="(reply, replyIndex) in row.certReplyList" :key="replyIndex">
                    <div class="write_wrap">
                      <div class="admin_name">{{ row.adminName }}</div>
                      <div class="write_date">{{ $moment(reply.regDate).format('YYYY.MM.DD HH:mm') }}</div>
                    </div>
                    <div class="inquire_content" v-html="$Util.nl2br(reply.content)"></div>
                  </div>
                  <div class="divider"></div>
                </li>
              </ul>
            </div>
          </div>
        </article>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      certList: [],
      certInquireList: [],
      progressInfoList: [],
      isWrite: false,
      progressTitle: '',
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo
      }
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  created: function () {
    this.getCertInfo()
  },
  methods: {
    getCertInfo: async function () {
      const res = await this.$CertSvc.getCertInfo(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity
      if (code === 1) {
        this.certList = entity.certList
        this.certInquireList = entity.certInquireList

        if (!this.$Util.isEmpty(this.certList)) {
          this.clickProgress(this.certList[0])
        }
      }
    },
    findProgressStatus: function (progressInfoList) {
      let find = progressInfoList.find(progress => progress.isCurrentProgress === 1);
      return find === undefined ? '' : find.progressStatus
    },
    clickProgress: function (cert) {
      this.progressTitle = cert.progress
      this.progressInfoList = cert.progressInfoList
    },
    clickReplyWrap: function () {
      this.isWrite = !this.isWrite
      setTimeout(() => {
        this.$refs.replyTextArea.focus()
      }, 1)
    },
    cancelReply: function () {
      this.isWrite = false
      this.$refs.replyTextArea.value = ''
    },
    submitReply: async function () {
      if (this.$refs.replyTextArea.value.length <= 0) {
        return false
      }

      const params = {
        type: 1,
        content: this.$refs.replyTextArea.value,
        userNo: this.userData.userNo
      }

      const res = await this.$CertSvc.registInquire(params)
      const code = res.code
      const message = res.message
      const entity = res.entity
      if (code === 1) {
        alert('문의가 접수 됐습니다.')
        this.$refs.replyTextArea.value = ''
        this.isWrite = false
        await this.getCertInfo()
      } else {
      }
    }
  }
}
</script>
